"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialAuthDtoProviderEnum = void 0;
exports.instanceOfSocialAuthDto = instanceOfSocialAuthDto;
exports.SocialAuthDtoFromJSON = SocialAuthDtoFromJSON;
exports.SocialAuthDtoFromJSONTyped = SocialAuthDtoFromJSONTyped;
exports.SocialAuthDtoToJSON = SocialAuthDtoToJSON;
exports.SocialAuthDtoToJSONTyped = SocialAuthDtoToJSONTyped;
/**
 * @export
 */
exports.SocialAuthDtoProviderEnum = {
    Google: 'google',
    Facebook: 'facebook',
    Apple: 'apple'
};
/**
 * Check if a given object implements the SocialAuthDto interface.
 */
function instanceOfSocialAuthDto(value) {
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    return true;
}
function SocialAuthDtoFromJSON(json) {
    return SocialAuthDtoFromJSONTyped(json, false);
}
function SocialAuthDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'provider': json['provider'],
        'redirectUri': json['redirectUri'] == null ? undefined : json['redirectUri'],
    };
}
function SocialAuthDtoToJSON(json) {
    return SocialAuthDtoToJSONTyped(json, false);
}
function SocialAuthDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'provider': value['provider'],
        'redirectUri': value['redirectUri'],
    };
}
